// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import isEmpty from 'lodash/isEmpty';

const hasTokens = (templates) =>
  templates
    .filter((t) => typeof t === 'string')
    .join('')
    .match(/#{(\w+[.\w+]+)\}/g);

export default ({ interpolationSource, templates }) => {
  const needsInterpolation = hasTokens(Object.values(templates));
  return (
    !needsInterpolation || (needsInterpolation && !isEmpty(interpolationSource))
  );
};
